































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { ToggleButton } from 'vue-js-toggle-button';
import VueMonthlyPicker from 'vue-monthly-picker';
import SearchIcon from 'mdi-vue/Magnify';
import FormInput from '@/components/FormInput.vue';
import ExportIcon from 'mdi-vue/FileExportOutline';
import TableBody from '@/components/Table/TableBody.vue';
import DeleteIcon from 'mdi-vue/Delete';
import { mapState } from 'vuex';
import api from '@/libs/api';
import { User } from '@/libs/api.interfaces';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Modal from '@/components/Modal.vue';
import TagInput from '@/components/TagInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import Tab from '@/components/Tab/Tab.vue';
import SearchField from '@/components/SearchField.vue';
import SearchRow from '@/components/SearchRow.vue';
import Select from '@/components/Select.vue';
import DatePicker, { DateRange } from '@/components/DatePicker.vue';
import ReportTable from './OnepayMerchantChannelTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    TagInput,
    Toggle,
    DeleteIcon,
    Modal,
    Table,
    Row,
    FormInput,
    TableBody,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    VueMonthlyPicker,
    ToggleButton,
    Tab,
    SearchIcon,
    ExportIcon,
    DatePicker,
    SearchField,
    SearchRow,
    Select,
    ReportTable,
  },
  computed: mapState(['user']),
})
export default class OnepayMerchant extends Vue {
  user!: {
    user: User;
  };

  myDataVariable = true;
  channelLabel = '';
  companyCode = '';
  companycodeshow = false;
  bin = '';
  binshow = false;
  checkboxshow = false;
  fullPayment = false;
  installment = false;
  tableInstalment = false;
  tenor = '';
  merchantId = '';
  codePlan = '';
  label = '';
  rowData: any = [];
  chanelParams: any = '';
  theParameters: any = {};

  channelparamslabel = false;
  klikpaylabel = false;

  showModalVa = false;

  currentChannel = {
    title: 'Credit Card',
    code: 'creditcard',
    path: 'creditcard',
  }

  searchOpen = false;
  showItemprpage = [
    { value: 10, label: '10' },
    { value: 25, label: '25' },
    { value: 50, label: '50' },
    { value: 100, label: '100' },
  ];

  transactionDate: DateRange = {
    startDate: null,
    endDate: null,
  }

  selectedMerchants: { merchant_code: string; merchant_name: string }[] = []
  tagIds: SelectItem[] = []
  channelIds: any = []
  loadingMerchant = false;
  loadingExport = false;
  modelLabel = 'Add Channel';

  channelIdList: string[] = [];
  loadingChannelId = false;

  merchants = [
    {
      /* eslint-disable @typescript-eslint/camelcase */
      merchant_code: '',
      merchant_name: 'Enter merchant name',
      $isDisabled: true,
      /* eslint-enable @typescript-eslint/camelcase */
    },
  ];

  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;

  $refs!: {
    report: ReportTable;
  }

  format!: (val: string) => string;

  mounted() {
    this.parseParams();
    this.getListData(1);
    this.showDetailInstallment();
    // this.getChannelIds();
  }

  deleteSelectedRow(indexData: any) {
    console.log('rowdata', this.rowData);
    console.log('indexdata', indexData);
    this.rowData.splice(indexData, 1);
  }

  showDetailInstallment() {
    if (this.installment === true) {
      this.tableInstalment = true;
    } else {
      this.tableInstalment = false;
    }
  }

  addNewColumn() {
    const myobject = {
      tenor: this.tenor,
      merchantId: this.merchantId,
      codePlan: this.codePlan,
      label: this.label,
    };

    this.rowData.push(myobject);

    this.tenor = '';
    this.merchantId = '';
    this.codePlan = '';
    this.label = '';
  }

  selectChanel() {
    // console.log('aaaaaaaaaaaaa', this.channelIds);
    this.binshow = false;
    this.companycodeshow = false;
    this.companycodeshow = false;
    this.binshow = false;
    this.checkboxshow = false;
    this.channelparamslabel = false;
    this.klikpaylabel = false;
    this.tableInstalment = false;
    this.fullPayment = false;
    this.installment = false;
    if (this.channelIds[0]) {
      const val = this.channelIds[0];
      if (
        val.service_code === '1011'
        || val.service_code === '1042'
        || val.service_code === '1043'
        || val.service_code === '1074'
        || val.service_code === '1062'
        || val.service_code === '1052'
        || val.service_code === '1090'
      ) {
        this.binshow = true;
        // this.bin = '';
        // this.bin = JSON.parse(val.channel_param).bin;
      } else if (val.service_code === '1021') {
        this.companycodeshow = true;
        // this.companyCode = JSON.parse(val.channel_param).company_code;
      } else if (val.service_code === '1032') {
        this.companycodeshow = true;
        this.binshow = true;
        // this.bin = '';
        // this.companyCode = JSON.parse(val.channel_param).company_code;
        // this.bin = JSON.parse(val.channel_param).bin;
      } else if (val.service_code === '1022') {
        this.checkboxshow = true;
        this.channelparamslabel = true;
        this.klikpaylabel = true;
        // this.fullPayment = JSON.parse(val.channel_param).kp_full_payment;
        // this.installment = JSON.parse(val.channel_param).kp_installment;
        // this.tableInstalment = JSON.parse(val.channel_param).kp_installment === true || false;
        // this.rowData = JSON.parse(val.channel_param).kp_installment_opt;
      }
    } else {
      this.bin = '';
      this.companyCode = '';
    }
  }

  async getListData(page: number) {
    /* eslint-disable @typescript-eslint/camelcase */
    const userRole = this.$route.params.user_role;
    const userGroup = this.$route.params.user_group;
    const merchId = this.$route.params.merch_id;
    if (page === 1 && this.$route.query.page) {
      const query = { ...this.$route.query };
      delete query.page;
      this.$router.replace({ query });
    }
    const params = {
      user_role: userRole,
      user_group: userGroup,
      merch_id: merchId,
      // limit: '5',
    };
    console.log('parameter', params);
    await this.$refs.report.getListData(params, page);
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  openModal(val: any) {
    if (val) {
      // console.log('value', val);
      this.chanelParams = val;
      if (
        val.service_code === '1011'
        || val.service_code === '1042'
        || val.service_code === '1043'
        || val.service_code === '1074'
        || val.service_code === '1062'
        || val.service_code === '1052'
        || val.service_code === '1090'
      ) {
        this.binshow = true;
        this.bin = JSON.parse(val.channel_param).bin;
      } else if (val.service_code === '1021') {
        this.companycodeshow = true;
        this.companyCode = JSON.parse(val.channel_param).company_code;
      } else if (val.service_code === '1032') {
        this.companycodeshow = true;
        this.binshow = true;
        this.companyCode = JSON.parse(val.channel_param).company_code;
        this.bin = JSON.parse(val.channel_param).bin;
      } else if (val.service_code === '1022') {
        this.checkboxshow = true;
        this.channelparamslabel = true;
        this.klikpaylabel = true;
        this.fullPayment = JSON.parse(val.channel_param).kp_full_payment;
        this.installment = JSON.parse(val.channel_param).kp_installment;
        this.tableInstalment = JSON.parse(val.channel_param).kp_installment === true || false;
        this.rowData = JSON.parse(val.channel_param).kp_installment_opt;
      }

      console.log('tabel', this.rowData);

      this.modelLabel = 'Update Channel';
      this.channelIds = val;
      this.channelLabel = val.channel_label;
    } else {
      this.bin = '';
      this.companyCode = '';
      this.availableChannel();
    }
    this.showModalVa = true;
    console.log('changed', val);
  }

  async availableChannel() {
    const userRole = this.$route.params.user_role;
    const userGroup = this.$route.params.user_group;
    const merchId = this.$route.params.merch_id;

    const { data } = await api.get('/onepay/merchants_edit_form', {
      params: {
        user_role: userRole,
        user_group: userGroup,
        merch_id: merchId,
      },
    });

    console.log('availabel', data.data.avaible_channel);
    this.channelIdList = data.data.avaible_channel;
  }

  merchantList() {
    this.$router.push('/onepay/onepaymerchant');
  }

  closeModal() {
    this.modelLabel = 'Add Channel';
    this.channelIds = [];
    this.channelLabel = '';
    this.companycodeshow = false;
    this.companyCode = '';
    this.binshow = false;
    this.bin = '';
    this.showModalVa = false;
    this.checkboxshow = false;
    this.channelparamslabel = false;
    this.klikpaylabel = false;
  }

  // async getChannelIds(merchant?: string[]) {
  //   try {
  //     this.loadingChannelId = true;
  //     const { data } = await api.get<ChannelIdResponse>('/transaction/channels', {
  //       params: {
  //         // eslint-disable-next-line @typescript-eslint/camelcase
  //         merchant_code: merchant || undefined,
  //       },
  //     });
  //     this.channelIdList = data.data.map((e) => e.channel_id);
  //     this.loadingChannelId = false;
  //   } catch (err) {
  //     console.error(err);
  //   }
  // }

  // @Watch('selectedMerchants')
  // onMerchantChange() {
  //   this.getChannelIds(this.selectedMerchants.map((e) => e.merchant_code));
  // }

  async getMerchants(query: string) {
    if (query === '') return;

    try {
      this.loadingMerchant = true;
      const { data } = await api.get('/merchants', {
        params: {
          name: query,
        },
      });
      this.merchants = data.data;
      this.loadingMerchant = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getTransaction(isExport = false, page: number) {
    const params = {
      channel: this.currentChannel,
      channelIds: this.channelIds,
    };

    if (isExport) {
      await this.$refs.report.export(params);
    } else {
      await this.$refs.report.getTransaction(params, false, page);
    }
  }

  parseParams() {
    this.showModalVa = false;
    const params = this.$route.query;

    if (typeof params.mc === 'string') {
      const merchants = JSON.parse(params.mc).map((e: { c: string; n: string }) => ({
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_code: e.c,
        merchant_name: e.n,
        /* eslint-enable @typescript-eslint/camelcase */
      }));
      this.selectedMerchants = merchants;
    } else {
      this.selectedMerchants = [];
    }

    if (typeof params.ch === 'string') {
      const channelIds = params.ch.split(',');
      this.channelIds = channelIds;
    } else {
      this.channelIds = [];
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getTransaction(false, page);
  }

  search() {
    this.$router.push({
      query: {
        ch: this.channelIds.length === 0 ? undefined : this.channelIds.join(','),
      },
    });
  }

  async addNewchannel() {
    /* eslint-disable @typescript-eslint/camelcase */
    const userRole = this.$route.params.user_role;
    const userGroup = this.$route.params.user_group;
    const merchId = this.$route.params.merch_id;
    if (this.modelLabel === 'Add Channel') {
      // console.log(this.channelIds[0]);
      // console.log('chanelid', this.channelIds);
      if (
        this.channelIds[0].service_code === '1011'
        || this.channelIds[0].service_code === '1042'
        || this.channelIds[0].service_code === '1043'
        || this.channelIds[0].service_code === '1074'
        || this.channelIds[0].service_code === '1062'
        || this.channelIds[0].service_code === '1052'
        || this.channelIds[0].service_code === '1090'
      ) {
        this.theParameters = {
          user_role: userRole,
          user_group: userGroup,
          channel_id: this.channelIds[0].channel_id,
          merch_id: merchId,
          channel_label: this.channelLabel,
          service_code: this.channelIds[0].service_code,
          is_active: this.myDataVariable === true ? 'on' : 'off',
          bin: this.bin,
        };
      } else if (this.channelIds[0].service_code === '1021') {
        this.theParameters = {
          user_role: userRole,
          user_group: userGroup,
          channel_id: this.channelIds[0].channel_id,
          merch_id: merchId,
          channel_label: this.channelLabel,
          service_code: this.channelIds[0].service_code,
          is_active: this.myDataVariable === true ? 'on' : 'off',
          company_code_mva: Number(this.companyCode),
          company_code: Number(this.companyCode),
        };
      } else if (this.channelIds[0].service_code === '1032') {
        this.theParameters = {
          user_role: userRole,
          user_group: userGroup,
          channel_id: this.channelIds[0].channel_id,
          merch_id: merchId,
          channel_label: this.channelLabel,
          service_code: this.channelIds[0].service_code,
          is_active: this.myDataVariable === true ? 'on' : 'off',
          company_code_mva: Number(this.companyCode) ? Number(this.companyCode) : '',
          company_code: Number(this.companyCode) ? Number(this.companyCode) : '',
          bin: this.bin,
        };
      } else if (this.channelIds[0].service_code === '1022') {
        this.theParameters = {
          user_role: userRole,
          user_group: userGroup,
          channel_id: this.channelIds[0].channel_id,
          merch_id: merchId,
          channel_label: this.channelLabel,
          service_code: this.channelIds[0].service_code,
          is_active: this.myDataVariable === true ? 'on' : 'off',
          kp_full_payment: this.fullPayment === true ? '1' : '0',
          kp_installment: this.installment === true ? '1' : '0',
          kk: this.rowData,
        };
      } else {
        this.theParameters = {
          user_role: userRole,
          user_group: userGroup,
          channel_id: this.channelIds[0].channel_id,
          merch_id: merchId,
          channel_label: this.channelLabel,
          service_code: this.channelIds[0].service_code,
          is_active: this.myDataVariable === true ? 'on' : 'off',
        };
      }
      console.log('chaneladd test', this.theParameters);
      await api.post('/onepay/channels_add', this.theParameters);

      const params = {
        user_role: userRole,
        user_group: userGroup,
        merch_id: merchId,
      };
      await this.$refs.report.getListData(params, 1);
    } else {
      console.log(this.channelIds);
      console.log('chanelParams', this.chanelParams.service_code);
      if (
        this.chanelParams.service_code === '1011'
        || this.chanelParams.service_code === '1042'
        || this.chanelParams.service_code === '1043'
        || this.chanelParams.service_code === '1074'
        || this.chanelParams.service_code === '1062'
        || this.chanelParams.service_code === '1052'
        || this.chanelParams.service_code === '1090'
      ) {
        this.theParameters = {
          user_role: userRole,
          user_group: userGroup,
          id: this.channelIds.id,
          merch_id: merchId,
          channel_label: this.channelLabel,
          service_code: this.channelIds.service_code,
          is_active: this.myDataVariable === true ? 'on' : 'off',
          bin: this.bin,
        };
      } else if (this.chanelParams.service_code === '1021') {
        this.theParameters = {
          user_role: userRole,
          user_group: userGroup,
          id: this.channelIds.id,
          merch_id: merchId,
          channel_label: this.channelLabel,
          service_code: this.channelIds.service_code,
          is_active: this.myDataVariable === true ? 'on' : 'off',
          company_code_mva: Number(this.companyCode),
          company_code: Number(this.companyCode),
        };
      } else if (this.chanelParams.service_code === '1032') {
        this.theParameters = {
          user_role: userRole,
          user_group: userGroup,
          id: this.channelIds.id,
          merch_id: merchId,
          channel_label: this.channelLabel,
          service_code: this.channelIds.service_code,
          is_active: this.myDataVariable === true ? 'on' : 'off',
          company_code_mva: Number(this.companyCode) ? Number(this.companyCode) : '',
          company_code: Number(this.companyCode) ? Number(this.companyCode) : '',
          bin: this.bin,
        };
      } else if (this.chanelParams.service_code === '1022') {
        this.theParameters = {
          user_role: userRole,
          user_group: userGroup,
          id: this.channelIds.id,
          merch_id: merchId,
          channel_label: this.channelLabel,
          service_code: this.channelIds.service_code,
          is_active: this.myDataVariable === true ? 'on' : 'off',
          kp_full_payment: this.fullPayment === true ? '1' : '0',
          kp_installment: this.installment === true ? '1' : '0',
          kk: this.rowData,
        };
      } else {
        this.theParameters = {
          user_role: userRole,
          user_group: userGroup,
          id: this.channelIds.id,
          merch_id: merchId,
          channel_label: this.channelLabel,
          service_code: this.channelIds.service_code,
          is_active: this.myDataVariable === true ? 'on' : 'off',
        };
      }
      console.log('parameterbyservicecode', this.theParameters);
      await api.post('/onepay/channels_edit', this.theParameters);

      const params = {
        user_role: userRole,
        user_group: userGroup,
        merch_id: merchId,
      };
      await this.$refs.report.getListData(params, 1);
      this.binshow = false;
      this.showModalVa = false;
      this.checkboxshow = false;
    }
    this.closeModal();
  }

  async exportData() {
    this.loadingExport = true;
    await this.getTransaction(true, 1);
    this.loadingExport = false;
  }

  cancel() {
    this.transactionDate = {
      startDate: null,
      endDate: null,
    };
    this.selectedMerchants = [];
    this.tagIds = [];
    this.channelIds = [];

    this.$router.push({
      query: {},
    });
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }
}
